import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {RouterModule, Routes} from '@angular/router';
import { PopupOrderComponent } from './popup-order/popup-order.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {HttpClient, HttpClientModule, HttpHandler} from '@angular/common/http';
import {NgxMaskModule} from 'ngx-mask';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { PopupTvProstoComponent } from './component/popup-tv-prosto/popup-tv-prosto.component';
import { SpecialPriceComponent } from './pages/tarrifs/component/special-price/special-price.component';
import { PopupTvLightComponent } from './component/popup-tv-light/popup-tv-light.component';
import { PopupTvBaseComponent } from './component/popup-tv-base/popup-tv-base.component';
import {MainComponent} from './pages/main/main.component';
import { PagesModule } from './pages/pages.module';
import { HeaderComponent } from './component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import {OtherComponent} from "./pages/other/other.component";
import { InfoComponent } from './pages/info/info.component';

const appRoutes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full'},
  { path: 'main', component: MainComponent},
  { path: 'contacts', component: ContactsComponent},
  { path: 'other', component: OtherComponent},
  { path: 'info', component: InfoComponent},
 /* { path: '**', component: AppComponent }*/
];

@NgModule({
  declarations: [
    AppComponent,
    PopupOrderComponent,
    PopupTvProstoComponent,
    PopupTvLightComponent,
    PopupTvBaseComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    PagesModule,
    RouterModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes),
    ReactiveFormsModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot(), // ToastrModule added
    BrowserAnimationsModule
  ],
  providers: [HttpClient],
  bootstrap: [AppComponent]
})
export class AppModule { }
